export default __webpack_public_path__ + "static/media/b2b-care-team.b561c4ef.png";